export const printPhone = (phone: string) => {
  if (!phone) return ''
  const cleaned = phone.trim().replace(/\s/g, '')
  if (cleaned.length === 10) {
    return cleaned.match(/.{1,2}/g)?.join(' ') || cleaned
  }
  return phone.trim()
}
